/**
 * Free-look pan input mapping (HEX-96). Pure arrow-key → camera-pan-delta
 * translation, factored out of the App shell so the direction logic is unit-
 * testable without booting Pixi or the persistence stack.
 *
 * Deltas are world-container pixel shifts: panning the *view* left (ArrowLeft)
 * shifts the world container right (+x) so more of the left enters frame; up
 * (ArrowUp) shifts it down (+y). Non-arrow keys return `null` (no pan).
 */

/** Default world-container shift per arrow press, in CSS pixels. */
export const PAN_STEP_PX = 96;

export interface PanDelta {
  readonly dx: number;
  readonly dy: number;
}

/**
 * Camera pan delta for a keyboard key while free-look is active, or `null` when
 * the key is not a pan key. `step` is the per-press shift (defaults to
 * `PAN_STEP_PX`).
 */
export function panDeltaForKey(key: string, step: number = PAN_STEP_PX): PanDelta | null {
  switch (key) {
    case 'ArrowLeft':
      return { dx: step, dy: 0 };
    case 'ArrowRight':
      return { dx: -step, dy: 0 };
    case 'ArrowUp':
      return { dx: 0, dy: step };
    case 'ArrowDown':
      return { dx: 0, dy: -step };
    default:
      return null;
  }
}
